module.exports = __webpack_public_path__ + "img/IMG_8805.485a18ab.jpg";